import { SET_HAS_TALENTS_DATA } from "redux/actions/hasTalentsActions";

let initialState = false;

const hasTalentsDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_HAS_TALENTS_DATA:
      return action.payload.value;
    default:
      return state;
  }
};

export default hasTalentsDataReducer;
